module.exports = __webpack_public_path__ + "img/Group_Elephant_Logo.c6b3ec9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Group_Elephant_Logo.svg
// module id = 583
// module chunks = 5